import { Resource } from "@examspark/types";

import { updateResource } from "./resource";

export const resolveIssue = async (
  issue: Resource,
  input: Partial<Resource>,
) => {
  const result = await updateResource({
    id: issue.id,
    sk: issue.sk,
    ...input,
  });

  return result.data?.updateResource;
};
